import { useEffect } from 'react';
import { getCompanySlug, getPortalUrlFlat } from '../utils/subdomain';

function Loading() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      جاري التحويل...
    </div>
  );
}

/** Redirect legacy path-based portal URLs to dedicated portal subdomains */
export default function LegacyPortalRedirect({ portal }) {
  const slug = getCompanySlug();

  useEffect(() => {
    if (!slug) return;
    const target = getPortalUrlFlat(slug, portal);
    if (!target) return;
    let path = '';
    if (portal === 'rider') {
      path = window.location.pathname.replace(/^\/rider/, '') || '';
    } else if (portal === 'merchant') {
      path = window.location.pathname.replace(/^\/m/, '') || '';
    }
    window.location.replace(target + path + window.location.search);
  }, [slug, portal]);

  return <Loading />;
}

export function RiderLegacyRedirect() {
  const slug = getCompanySlug();

  useEffect(() => {
    if (!slug) return;
    const target = getPortalUrlFlat(slug, 'rider');
    const path = window.location.pathname.replace(/^\/rider_v2/, '') || '';
    if (target) window.location.replace(target + path + window.location.search);
  }, [slug]);

  return <Loading />;
}
